
(() => {
  const FORM = 'product-form-component';
  const NOTICE = '.blush-backorder-notice';
  const CHECKBOX = '.blush-backorder-acknowledge';
  const BUTTON = 'button[name="add"]';
  const INVENTORY = '.blush-variant-inventory';

  function updateForm(component) {
    const form = component.querySelector('form');
    const notice = component.querySelector(NOTICE);
    const checkbox = component.querySelector(CHECKBOX);
    const button = component.querySelector(BUTTON);
    const inventoryElement = component.querySelector(INVENTORY);
    const variantInput = form?.querySelector('input[name="id"]');

    if (!form || !notice || !checkbox ||
        !button || !inventoryElement || !variantInput) return;

    let variants;

    try {
      variants = JSON.parse(inventoryElement.textContent);
    } catch {
      return;
    }

    const variantId = variantInput.value;
    const variant = variants[variantId];

    if (!variant) return;

    const isBackorder =
      variant.managed === 'shopify' &&
      variant.inventory <= 0 &&
      variant.policy === 'continue' &&
      variant.available;

    const previousVariant = component.dataset.blushVariantId;

    if (previousVariant !== variantId) {
      checkbox.checked = false;
      component.dataset.blushVariantId = variantId;
    }

    notice.hidden = !isBackorder;

    // Only unlock buttons that our script previously locked.
    if (button.dataset.blushBackorderLocked === 'true') {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      delete button.dataset.blushBackorderLocked;
    }

    // Preserve Shopify's sold-out button state.
    if (button.disabled) return;

    if (isBackorder && !checkbox.checked) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.dataset.blushBackorderLocked = 'true';
    }
  }

  function updateAllForms() {
    document.querySelectorAll(FORM).forEach(updateForm);
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches(CHECKBOX)) {
      const component = event.target.closest(FORM);
      if (component) updateForm(component);
    }

    if (event.target.matches('input[name="id"]')) {
      updateAllForms();
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest(BUTTON);
    if (!button) return;

    const component = button.closest(FORM);
    if (!component) return;

    const notice = component.querySelector(NOTICE);
    const checkbox = component.querySelector(CHECKBOX);

    if (notice && !notice.hidden && !checkbox?.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const observer = new MutationObserver(() => {
    updateAllForms();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['value']
  });

  updateAllForms();
})();
